/**
 * Abre uma determinada url em uma nova janela
 */
export function openNewTab(url) {
  const win = window.open(url, '_blank');
  win.focus();
}
